import {Injectable} from '@angular/core';
import {ColumnApi, ColumnResizedEvent, FirstDataRenderedEvent, GridApi} from "ag-grid-community";

@Injectable({
  providedIn: 'root'
})
export class DynamicTooltipService {
  updateTooltips(api: GridApi, columnApi: ColumnApi) {
    const column = columnApi.getColumn('value'); // Holt die echte Column-Instanz
    if (!column) return;

    const width = column.getActualWidth(); // Holt die tatsächliche Spaltenbreite

    api.forEachNode(node => {
      api.applyTransaction({
        update: [{...node.data, tooltip: node.data?.value?.length > (width - 34) / 12 ? node.data.value : ''}]
      });
    });
  }

  onFirstDataRendered(params: FirstDataRenderedEvent) {
    this.updateTooltips(params.api, params.columnApi);
  }

  onColumnResized(params: ColumnResizedEvent) {
    if (params.finished) { // Nur nach Abschluss des Resizing ausführen
      this.updateTooltips(params.api, params.columnApi);
    }
  }
}
